import { useMemo } from "react";

import PropTypes from "prop-types";

import Async from "./Async";
import Simple from "./Simple";

const MODES = {
  simple: Simple,
  async: Async,
};

const Select = ({ type, ...props }) => {
  const View = useMemo(() => MODES[type], [type]);
  return <View {...props} />;
};

Select.propTypes = {
  type: PropTypes.oneOf(Object.keys(MODES)),
};

Select.defaultProps = {
  type: "simple",
};

export default Select;
